import { render, staticRenderFns } from "./PanelInstall.vue?vue&type=template&id=140b588f&scoped=true&"
import script from "./PanelInstall.vue?vue&type=script&lang=js&"
export * from "./PanelInstall.vue?vue&type=script&lang=js&"
import style0 from "./PanelInstall.vue?vue&type=style&index=0&id=140b588f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b588f",
  null
  
)

export default component.exports